import Http from '../common/http';
import ApiUtil from "../utils/api.util";
import StringUtil from '../utils/string.util';

const RESOURCE = 'invoice';

const InvoiceService = {
  downloadPdf(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Http.post(`/${RESOURCE}/${id}/pdf`, null, false, {
          responseType: 'blob',
        });

        const headers = response.headers;
        const data = response.data;

        let fileName = ApiUtil.getFileNameFromHeader(headers);

        if (fileName) {
          fileName = StringUtil.rawurldecode(fileName);
        }

        if (!fileName) {
          fileName = `Invoice_${id}.pdf`;
        }

        resolve({
          data,
          fileName
        });
      } catch (e) {
        reject(e);
      }
    });
  },
  downloadDepartmentPdf(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Http.post(`/${RESOURCE}/${id}/department-pdf`, null, false, {
          responseType: 'blob',
        });

        const headers = response.headers;
        const data = response.data;

        let fileName = ApiUtil.getFileNameFromHeader(headers);
``
        if (fileName) {
          fileName = StringUtil.rawurldecode(fileName);
        }

        if (!fileName) {
          fileName = `Department_${id}.pdf`;
        }

        resolve({
          data,
          fileName
        });
      } catch (e) {
        reject(e);
      }
    });
  },
  downloadReportByRegionExcel(id) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await Http.post(`/${RESOURCE}/${id}/report-by-region-excel`, null, false, {
          responseType: 'blob',
        });

        const headers = response.headers;
        const data = response.data;

        let fileName = ApiUtil.getFileNameFromHeader(headers);
        ``
        if (fileName) {
          fileName = StringUtil.rawurldecode(fileName);
        }

        if (!fileName) {
          fileName = `Region_${id}.xlsx`;
        }

        resolve({
          data,
          fileName
        });
      } catch (e) {
        reject(e);
      }
    });
  },
  detail(id){
    return Http.get(`/${RESOURCE}/detail/${id}`);
  },
  delete(id){
    return Http.delete(`/${RESOURCE}/${id}`);
  }
};

export default InvoiceService;
